import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

import html2pdf from "html2pdf.js";
import { useNavigate } from "react-router-dom";
import {
  AddDeputyAllotementInDataBase,
  ManulaAllotement,
} from "../../../CrudOperations/PostOperation";
import CrystalReport from "../../CrystalReport/CrystalReport";
import AreaSection from "./AreaSection";
import ManulaAllotementModal from "../ReserveManulaAllotementModal";
import ColorBadge from "../../ColorBadge";
import {
  getArea_ByEventDetailsID,
  getDuttyAllotement,
  getEvent_AllottedData,
  getEventList,
  getReservedAllotedStaff,
} from "../../../CrudOperations/GetOperation";
import useTruncate from "../../../../Utility/useTruncate";
import ReserveManulaAllotementModal from "../ReserveManulaAllotementModal";
import useFull_ReserveDutyAllotemetn_Hook from "./useFull_ReserveDutyAllotemetn_Hook";

// Reusable Stat Card Component
const StatCard = ({
  title,
  subtitle,
  subSubTitle,
  colors,
  onClick,
  tag,
  isActive,
}) => (
  <div
    onClick={onClick}
    className={`relative cursor-pointer ${colors} p-5 rounded-xl shadow-md transition 
      ${isActive ? "scale-105 shadow-lg" : ""} 
      hover:scale-105 hover:shadow-lg text-white`}
  >
    {/* Corner Tag */}
    {tag && (
      <div className="absolute top-2 right-2 bg-white text-xs text-gray-800 font-semibold px-2 py-1 rounded-full shadow">
        {tag === "bg-red-500"
          ? "Past"
          : tag === "bg-green-500"
          ? "Current"
          : tag === "bg-blue-500"
          ? "Upcoming"
          : "error"}
      </div>
    )}

    <h3 className="text-xl font-semibold">{subtitle}</h3>
    <h2 className="text-md text-gray-200 font-semibold">{title}</h2>
    <h2 className="text-md text-gray-200 font-semibold">{subSubTitle}</h2>
  </div>
);

const ReserveDutyAllotementBase = () => {
  const { checkpoints , submitForm} = useFull_ReserveDutyAllotemetn_Hook();
  console.log(checkpoints);

  const reportRef = useRef();
  const [DuttyAlloment, setDuttyAlloment] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [selectedDeputyCheckpointId, setselectedDeputyCheckpointId] =
    useState(null);
  const [Loading, setLoading] = useState(false);

  const truncate = useTruncate(10);

  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [duttyAllotments, setDuttyAllotments] = useState([]);
  const [filteredDuttyAllotments, setFilteredDuttyAllotments] = useState([]);
  const [checkpointss, setcheckpointss] = useState(checkpoints);
  const [Filtered_checkpoints, setFiltered_checkpoints] = useState(checkpoints);

  const [OpenManualAllotement, setOpenManualAllotement] = useState(false);
  const [ManualAllotementData, setManualAllotementData] = useState("");

  // here data comes
  console.log(checkpoints);

  useEffect(() => {
    setFiltered_checkpoints(checkpoints);
    setcheckpointss(checkpoints);
  }, [checkpoints, Filtered_checkpoints, checkpointss]);

  const [ReservedDeputy, setReservedDeputy] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const dutyRes = await getDuttyAllotement();
      if (dutyRes?.data?.Message === "Success") {
        setDuttyAllotments(dutyRes.data.AllottedDeputies);
        setFilteredDuttyAllotments(dutyRes.data.AllottedDeputies);
      }
    };

    // fetchData();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = checkpointss.filter((d) =>
      d.EventName.toLowerCase().includes(query)
    );
    setFiltered_checkpoints(filtered);
  };

  const handleEventClick = async (DeputyCheckpointId) => {
    setselectedDeputyCheckpointId(DeputyCheckpointId); // highlight clicked card

    const res = await getReservedAllotedStaff(DeputyCheckpointId);
    console.log(res);

    if (res.data?.Message === "Success") {
      setReservedDeputy(res.data.Data);
    } else if (
      res?.data?.ServerMessage == "No staff allotted for this checkpoint."
    ) {
      setReservedDeputy([]);

      toast.warn(res?.data?.ServerMessage );
    } else {
      toast.error("Failed to fetch ReservedDeputy.");
    }
  };

  const handleDownload = () => {
    if (!ReservedDeputy.isAllotted) {
      return toast.warn("Deputies have not been allocated yet.");
    }

    const element = reportRef.current;

    html2pdf()
      .set({
        margin: 0,
        filename: "Deputy-Allottement-Report.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"], before: "#pagebreak" },
      })
      .from(element)
      .save();
  };

  const handleDutyAllotement = async () => {
    if (!selectedDeputyCheckpointId) {
      return toast.warn("Please Select an Event");
    }

    if (!ReservedDeputy.ReservedDeputy.length > 0) {
      return toast.warn("No area has been defined for deputy allocation.");
    }

    const AllocationResponse = await AddDeputyAllotementInDataBase(
      selectedDeputyCheckpointId
    );

    if (
      AllocationResponse.data.ServerMessage ==
      "Cannot allot staff because geotagging time interval has not been set for this event."
    ) {
      toast.warn(
        "Cannot allot staff because geotagging time interval has not been set for this event."
      );
      setLoading(true);

      const eventDetailsName =
        checkpointss.length > 0 &&
        checkpointss.find(
          (ele) => ele.EventDetailId == selectedDeputyCheckpointId
        );

      setTimeout(() => {
        navigate(`/${localStorage.getItem("token")}/geo-tag`);

        toast.warn(
          <span>
            Please set geotagging time here for{" "}
            <strong>{eventDetailsName.EventName}</strong>
          </span>
        );
        setLoading(true);
      }, 5000);
    } else if (AllocationResponse.data.Message == "Success") {
      setDuttyAlloment(AllocationResponse.data.Data);

      toast.success("Dutty Allotted Successfully!");
    }
  };

  const handleView = async () => {
    if (!selectedDeputyCheckpointId) {
      return toast.warn("Please Select an Event");
    }

    // selectedDeputyCheckpointId
    // if (!ReservedDeputy.isAllotted) {
    //   return toast.warn("Deputies have not been allocated yet.");
    // }

    const response = await getEvent_AllottedData(selectedDeputyCheckpointId);

    if (response.data.Message == "Success") {
      navigate(`/${localStorage.getItem("token")}/view-Allotment`, {
        replace: true,
        state: { data: response.data.Data },
      });
    } else if (
      response.data.ServerMessage == "No staff allotted for this event."
    ) {
      toast.warn(response.data.ServerMessage);
    }
  };


  const handleOnSubmit = async()=>{

  }

  const handleManulAllotement = () => {
    if (!selectedDeputyCheckpointId) {
      toast.warn("Please Select Event!!!");
      return;
    }

    setOpenManualAllotement(true);
    setManualAllotementData(selectedDeputyCheckpointId);
    // const response = await ManulaAllotement();
  };

  const handleManualOnSubmit = () => {
    toast.warn("......");
  };

  const getcheckpointsstatusClass = (startDate, endDate) => {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const start = new Date(startDate);
    const end = new Date(endDate);

    if (end < today) return "bg-red-500"; // Past
    if (start >= today && start < tomorrow) return "bg-green-500"; // Today
    if (start >= tomorrow) return "bg-blue-500"; // Upcoming
    return "bg-yellow-500";
  };

  if (Loading)
    return (
      <div className="flex justify-center items-center h-full">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );

  return (
    <div className=" p-6 md:p-10 bg-white rounded-lg shadow-lg">
      <h1 className="text-2xl font-bold text-gray-800 mb-6 border-b-4 border-blue-600 pb-2">
        Reserve Duty Allotment Dashboard
      </h1>

      {/* Action Bar */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <input
          type="text"
          placeholder="Search by Checkpoints..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-full md:w-1/2 border border-gray-300 px-4 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* checkpointss Section */}
        <div className="bg-gray-50 p-4 rounded-md shadow">
          <div className="flex flex-row justify-between mb-3">
            <h2 className="text-lg font-semibold text-gray-700 mb-4">
              CheckPoints
            </h2>

            <div className="flex gap-4  rounded-md px-3 text-sm">
              {/* <ColorBadge label="Current CheckPoint" status="Current_Event" /> */}
              {/* <ColorBadge label="Past Event" status="Past_Event" /> */}
              {/* <ColorBadge label="Upcoming Event" status="Comming_Event" /> */}
              {/* <ColorBadge label="Pending Approval" status="pending" /> */}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {Filtered_checkpoints.length > 0 ? (
              Filtered_checkpoints.map((cp) => (
                <StatCard
                  key={cp.DeputyCheckpointId}
                  title={truncate(cp.DeputyCheckpointName)}
                  colors={`border-b text-black transition-colors duration-200 ${getcheckpointsstatusClass(
                    cp.StartDate,
                    cp.EndDate
                  )}`}
                  onClick={() => handleEventClick(cp.DeputyCheckpointId)}
                  tag={getcheckpointsstatusClass(cp.StartDate, cp.EndDate)}
                  isActive={
                    selectedDeputyCheckpointId === cp.DeputyCheckpointId
                  } // ← this line
                />
              ))
            ) : (
              <p className="text-gray-500">No checkpointss found.</p>
            )}
          </div>
        </div>

        {/* ReservedDeputy Section */}
        <AreaSection
         OpenManualAllotement = {OpenManualAllotement }
          setOpenManualAllotement = {setOpenManualAllotement}
        submitForm = {submitForm}
        selectedDeputyCheckpointId ={selectedDeputyCheckpointId}
          handleView={handleView}
          ReservedDeputy={ReservedDeputy}
          handleManulAllotement={handleManulAllotement}
        />
      </div>

      <div
        ref={reportRef}
        className="p-4 bg-white text-black max-w-3xl mx-auto mt-8 hidden"
      >
        <CrystalReport props={DuttyAlloment} />
      </div>


      {/* Modal Placeholder */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
            <h2 className="text-xl font-bold mb-4">Add Deputy Form</h2>
            {/* Include your modal form here */}
            <button
              onClick={() => setIsModalOpen(false)}
              className="mt-4 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReserveDutyAllotementBase;
